import React from 'react';
import PlainCRUD from 'components/PlainCRUD';
import {
  deleteTipoDeCredito,
  getTiposDeCredito,
  patchTipoDeCredito,
  postTipoDeCredito,
} from 'api/pae/tiposDeCredito';
import { defaultFields } from 'components/PaginatedPlainCRUD';
import { capitalize } from 'utils/normalizers';

export const permissionConfig = {
  permissionModel: 'tipodecreditopae',
};

// eslint-disable-next-line react/prop-types
const TiposDeCredito = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Crédito"
    get={getTiposDeCredito}
    post={postTipoDeCredito}
    patch={patchTipoDeCredito}
    delete={deleteTipoDeCredito}
    permission={permission}
    disabledStateField
    tableProps={{
      allowColumnSelector: false,
      deleteText: 'Cancelar',
    }}
    fields={[
      {
        ...defaultFields.descripcion,
        normalize: (value) => capitalize(value),
      },
    ]}
  />
);

export default TiposDeCredito;
